import api from '../utils/api';

export interface CreditStatus {
  currentCredits: number;
  totalCredits: number;
  pctRemaining: number;
  alertLevel: 'ok' | 'warning' | 'critical';
  rechargeUrl: string;
}

export const creditsApi = {
  getStatus: async (): Promise<CreditStatus> => {
    const { data } = await api.get<CreditStatus>('/credits/status');
    return data;
  },
};
